import Vue from 'vue'
import Router from 'vue-router'
import home from '../page/homeView.vue'
import news from '../page/newsView.vue'
import big from '../page/bigView.vue'
import video from '../page/videoView.vue'
import policy from '../page/policyView.vue'
import featured from '../page/featuredView.vue'
import detail from '../page/detailView.vue'
import pages from '../page/pagesView.vue'
import search from '../page/searchView.vue'
import about from '../page/aboutView.vue'
import member from '../page/memberView.vue'
import login from '../page/loginView.vue'
import register from '../page/registerView.vue'
import memberIndex from '../page/memberIndex.vue'
import feedback from '../page/feedback.vue'
import agreement from '../page/agreement.vue'
import privacy from '../page/privacy.vue'
import comment from '../page/commentView.vue'
import opinion from '../page/opinionView.vue'
import memberAbout from '../page/memberAbout.vue'
Vue.use(Router)


export default new Router({
  mode: 'history',
  routes: [
    {
        path: '/',
        redirect: '/pages/'
    },
    {
        path: '/pages',
        component: pages,
        children: [
        {
            path: '',
            redirect: '/pages/home'
        },
        {
            path: 'home',
            name: 'homeView',
            component: home
        },
        {
            path: 'news',
            name: 'newsView',
            component: news
        },
        {
            path: 'big',
            name: 'bigView',
            component: big
        },
        {
            path: 'video',
            component: video,
            name: 'videoView'
        },
        {
            path: 'policy',
            name: 'policyView',
            component: policy
        },
        {
            path: 'featured',
            name: 'featuredView',
            component: featured
        },
        {
            path: '/search/:keyword',
            name: 'searchView',
            component: search
        },
        {
            path: '/about/:detail_type/:aboutkey',
            name: 'aboutView',
            component: about
        }
        ]
    },
    {
        path: '/member',
        component: member,
        children : [
        {
            path: '',
            redirect: '/member/index'
        },
        {
            path: 'index',
            name: 'memberIndex',
            meta: {
                title : '个人中心'
            },
            component: memberIndex
        },
        {
            path: 'login/:from',
            name: 'loginView',
            meta: {
                title : '登录'
            },
            component: login
        },
        {
            path: 'register',
            name: 'registerView',
            meta: {
                title : '注册'
            },
            component: register
        },
        {
            path: 'feedback/:detail_type',
            name: 'feedbackView',
            meta: {
                title : '用户反馈'
            },
            component: feedback
        },
        {
            path: 'agreement/:detail_type',
            name: 'agreementView',
            meta: {
                title : '用户协议'
            },
            component: agreement
        },
        {
            path: 'privacy/:detail_type',
            name: 'privacyView',
            meta: {
                title : '隐私政策'
            },
            component: privacy
        },
        {
            path: 'comment',
            name: 'commentView',
            meta: {
                title : '我的评论'
            },
            component: comment
        },
        {
            path: 'opinion',
            name: 'opinionView',
            meta: {
                title : '反馈意见'
            },
            component: opinion
        },
        {
            path: 'about',
            name: 'memberAbout',
            meta: {
                title : '关于'
            },
            component: memberAbout
        }
        ]
    },
    {
        path: '/detail/:detail_type/:cid/:id',
        name: 'detailView',
        components: {
            default: pages,
            detail: detail
        }
    },
  ],
  linkActiveClass: 'active',
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js